/** Shared by upload previews, attachment prompts and microphone drafts. */
export const AUDIO_MIME_TYPES: Readonly<Record<string, string>> = Object.freeze({
  mp3: 'audio/mpeg',
  mpga: 'audio/mpeg',
  mpeg: 'audio/mpeg',
  wav: 'audio/wav',
  m4a: 'audio/mp4',
  mp4: 'audio/mp4',
  aac: 'audio/aac',
  ogg: 'audio/ogg',
  oga: 'audio/ogg',
  opus: 'audio/ogg',
  webm: 'audio/webm',
  flac: 'audio/flac',
});

export function audioMimeForPath(path: string): string | null {
  const extension = path.split('.').pop()?.toLowerCase() ?? '';
  return Object.hasOwn(AUDIO_MIME_TYPES, extension) ? AUDIO_MIME_TYPES[extension] : null;
}

export function isAudioPath(path: string): boolean {
  return audioMimeForPath(path) !== null;
}
